import { ref } from 'vue'

const tableHoverField = ref()
export default tableHoverField
